import { render, staticRenderFns } from "./app-bar-locale.vue?vue&type=template&id=ba721b5e&scoped=true&lang=pug&"
import script from "./app-bar-locale.vue?vue&type=script&lang=ts&"
export * from "./app-bar-locale.vue?vue&type=script&lang=ts&"
import style0 from "./app-bar-locale.vue?vue&type=style&index=0&id=ba721b5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba721b5e",
  null
  
)

export default component.exports